<ss-dynamic-form [controls]="controlsObs | async" [applyValidation]="isSelectedSubject | async"></ss-dynamic-form>
<div class="flex-row">
    <p *ngIf="validationMessageObs | async" class="error-text">{{validationMessageObs | async}}
    </p>
</div>